import './identifiers-fields-area.scss'

import Vue from "vue";
import Component from "vue-class-component";

import { ConditionReport } from '@skinsoft/entity';
import { ReportFeatured } from '@skinsoft/entity-ui';
import { EnhancedTextInput, Form, ThesaurusTermChooser } from '@skinsoft/ui';

@Component({
    components: {
        sEnhancedTextInput: EnhancedTextInput,
        sThesaurusTermChooser: ThesaurusTermChooser
    },
    props: ["reportFeatured", "conditionReport", "form", "fieldName"],
    template: require("./identifiers-fields-area.html")
})
export class IdentifierFieldsArea extends Vue {

    public reportFeatured: ReportFeatured;
    public conditionReport: ConditionReport;
    public fieldName: string;

    public form: Form;


    // getters returning fields name according to data path in condition report object
    public get referenceNumberFieldName() {
        return `${this.fieldName}.conditionReportCS.referenceNumber`
    }

    public get reportReasonFieldName() {
        return `${this.fieldName}.conditionReportCS.reportReason.translatedString.${this.$i18n.locale}`
    }

    public get precisionsFieldName() {
        return "" // TODO Implement when fields exists in the API
    }

    public get reportTypeFieldName() {
        return `${this.fieldName}.conditionReportCS.reportType`
    }

}